import GalleryWrapper from '../../../../../pages/vip/features/gallery/gallery.mobile';

export default GalleryWrapper;
